import CommonTable from 'components/table/CommonTable';
import { ICal } from 'models/ICal';
import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const CalendarImportSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const CalendarImportFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  .form-group {
    margin-bottom: 0;
  }

  button[type='submit'] {
    width: 100%;
  }

  ${mediaQuery.xs} {
    gap: 0;

    button[type='submit'] {
      margin-top: 18px;
    }

    .form-group {
      margin-bottom: 15px;
    }
  }
`;

export const CalendarImportTableStyled = styled(CommonTable<ICal>)`
  .column-type {
    width: 250px;
  }

  .column-actions {
    width: 100px;
  }
`;
